import { z } from 'zod'

export const SeedStateDto = z.object({
  adminFixtures: z.object({
    corruptUserId: z.string(),
    corruptUserName: z.string(),
  }),
  testAccount: z.object({
    userId: z.string(),
    archiveBundleId: z.string(),
    archiveBundleTitle: z.string(),
    bundleIdsByTitle: z.record(z.string()),
    collectionId: z.string(),
    distributionKeyId: z.string(),
    monocleVideoBundleId: z.string(),
    monocleVideoBundleTitle: z.string(),
    packageBundleId: z.string().nullable(),
    primeJobBundleId: z.string(),
    primeJobBundleTitle: z.string(),
    primaryBundleId: z.string(),
    primaryBundleTitle: z.string(),
  }),
  trialAccounts: z
    .object({
      expiredBundleId: z.string(),
      expiredBundleTitle: z.string(),
      expiredCollectionId: z.string(),
      expiredDistributionKeyId: z.string(),
      nearBundleId: z.string(),
      nearBundleTitle: z.string(),
    })
    .optional(),
})

export type SeedState = z.infer<typeof SeedStateDto>
